module.exports = __webpack_public_path__ + "media/img/ruby-ico-32f6c4ca.png";